import { HTMLAttributes } from 'react';
import { scale } from '../../util/scale';
import { colors } from '../../style/theme';

const table = scale({
  borderCollapse: 'collapse',
});

const header = scale({
  borderBottom: `2px solid ${colors.gray5}`,
});

const headerCell = scale({
  padding: 8,
  fontWeight: 700,
  textAlign: 'left',
  paddingBottom: 4,
  borderBottom: `2px solid ${colors.borderColor}`,
});

const tableRow = scale({
  borderCollapse: 'collapse',
});

const cell = scale({
  border: `2px solid ${colors.gray9}`,
  padding: 8,
  paddingRight: 16,
  '&:first-child': {
    borderLeft: 0,
  },
  '&:last-child': {
    borderRight: 0,
  },
});

export default function Table({
  className,
  headings,
  rows,
}: {
  rows: React.ReactNode[][];
  headings: React.ReactNode[];
} & HTMLAttributes<HTMLTableElement>) {
  return (
    <div
      css={{
        overflowX: 'scroll',
        '&::-webkit-scrollbar': {
          backgroundColor: 'transparent',
          height: 10,
        },
        '&::-webkit-scrollbar-thumb': {
          minWidth: 10,
          backgroundColor: colors.gray9,
          borderRadius: 16,
          '&:hover': {
            backgroundColor: colors.gray6,
          },
        },
      }}
    >
      <table css={table} className={className}>
        <thead>
          <tr css={header}>
            {headings.map((heading, i) => (
              <th key={i} css={headerCell}>
                {heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} css={tableRow}>
              {row.map((data, j) => (
                <td key={j} css={cell}>
                  {data}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
